import React from 'react';

export default function Sorting() {
  return (
    <svg width="13" height="11" viewBox="0 0 13 11" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M0 1.15625C0 0.800781 0.273438 0.5 0.65625 0.5H11.5938C11.9492 0.5 12.25 0.800781 12.25 1.15625C12.25 1.53906 11.9492 1.8125 11.5938 1.8125H0.65625C0.273438 1.8125 0 1.53906 0 1.15625ZM0 5.53125C0 5.17578 0.273438 4.875 0.65625 4.875H8.09375C8.44922 4.875 8.75 5.17578 8.75 5.53125C8.75 5.91406 8.44922 6.1875 8.09375 6.1875H0.65625C0.273438 6.1875 0 5.91406 0 5.53125ZM5.25 9.90625C5.25 10.2891 4.94922 10.5625 4.59375 10.5625H0.65625C0.273438 10.5625 0 10.2891 0 9.90625C0 9.55078 0.273438 9.25 0.65625 9.25H4.59375C4.94922 9.25 5.25 9.55078 5.25 9.90625Z"
        fill="currentColor"
      />
    </svg>
  );
}
